import { render, staticRenderFns } from "./ProfitlossReport.vue?vue&type=template&id=6ee80ecd&"
import script from "./ProfitlossReport.vue?vue&type=script&lang=js&"
export * from "./ProfitlossReport.vue?vue&type=script&lang=js&"
import style0 from "./ProfitlossReport.vue?vue&type=style&index=0&id=6ee80ecd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports